import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ef9f881"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid-item" }
const _hoisted_2 = { class: "grid-item-head" }
const _hoisted_3 = { class: "grid-item-head-index" }
const _hoisted_4 = { class: "grid-item-head-title" }
const _hoisted_5 = { class: "grid-item-body" }
const _hoisted_6 = { class: "wind-meter-wrapper" }
const _hoisted_7 = { class: "others-panel" }
const _hoisted_8 = { class: "others-panel-head" }
const _hoisted_9 = { class: "update-time" }
const _hoisted_10 = { class: "update-time-inner" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "更新時刻", -1))
const _hoisted_12 = { class: "others-panel-body" }
const _hoisted_13 = { class: "left-pane" }
const _hoisted_14 = { class: "others-panel-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "others-panel-item-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon wind" }),
  /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, [
    /*#__PURE__*/_createTextVNode(" １０分間"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 最大瞬間"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 風向風速 ")
  ])
], -1))
const _hoisted_16 = { class: "others-panel-item-body" }
const _hoisted_17 = { class: "direction" }
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "others-panel-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "others-panel-item-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon tempature" }),
  /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "気 温")
], -1))
const _hoisted_21 = { class: "others-panel-item-body" }
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "others-panel-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "others-panel-item-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon humid" }),
  /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "湿 度")
], -1))
const _hoisted_25 = { class: "others-panel-item-body" }
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "others-panel-item" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "others-panel-item-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon humid" }),
  /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "現地気圧")
], -1))
const _hoisted_29 = { class: "others-panel-item-body" }
const _hoisted_30 = { class: "value" }
const _hoisted_31 = { class: "right-pane" }
const _hoisted_32 = { class: "others-panel-item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "others-panel-item-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon rain" }),
  /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "10分雨量")
], -1))
const _hoisted_34 = { class: "others-panel-item-body" }
const _hoisted_35 = { class: "value" }
const _hoisted_36 = { class: "others-panel-item" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "others-panel-item-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon rain" }),
  /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "1時間雨量")
], -1))
const _hoisted_38 = { class: "others-panel-item-body" }
const _hoisted_39 = { class: "value" }
const _hoisted_40 = { class: "others-panel-item" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "others-panel-item-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon rain" }),
  /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "累計雨量")
], -1))
const _hoisted_42 = { class: "others-panel-item-body" }
const _hoisted_43 = { class: "value" }
const _hoisted_44 = { class: "others-panel-item" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "others-panel-item-label" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon rain" }),
  /*#__PURE__*/_createElementVNode("div", { class: "label-text" }, "降雨強度")
], -1))
const _hoisted_46 = { class: "others-panel-item-body" }
const _hoisted_47 = { class: "value" }

import { computed } from 'vue'
import WindMeter from '@/components/common/WindMeter.vue'
import { windDirectionLabel } from '@/lib/constants'

type WindPanelUIProps = {
  no: number
  stationName: string
  updatedAt: string
  windDirection?: number
  windStrength?: string
  maxWindDirection?: number
  maxWindStrength?: string
  tempature?: string
  humid?: string
  press?: string
  rainMin10?: string
  rainMin60?: string
  rainRui?: string
  rainfall?: string
}

export default /*#__PURE__*/_defineComponent({
  props: {
    no: null,
    stationName: null,
    updatedAt: null,
    windDirection: null,
    windStrength: null,
    maxWindDirection: null,
    maxWindStrength: null,
    tempature: null,
    humid: null,
    press: null,
    rainMin10: null,
    rainMin60: null,
    rainRui: null,
    rainfall: null
  },
  setup(__props: any) {

const props = __props as {
  no: number
  stationName: string
  updatedAt: string
  windDirection?: number
  windStrength?: string
  maxWindDirection?: number
  maxWindStrength?: string
  tempature?: string
  humid?: string
  press?: string
  rainMin10?: string
  rainMin60?: string
  rainRui?: string
  rainfall?: string
}



const maxWindDirectionText = computed(() => {
  const direction = props.maxWindDirection

  return windDirectionLabel(direction)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.no), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(__props.stationName), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(WindMeter, {
          windDirection: __props.windDirection,
          windStrength: __props.windStrength
        }, null, 8, ["windDirection", "windStrength"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("p", null, _toDisplayString(__props.updatedAt), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(maxWindDirectionText)), 1),
                _createElementVNode("div", _hoisted_18, _toDisplayString(__props.maxWindStrength) + " m/s", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, _toDisplayString(__props.tempature) + " ℃", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, _toDisplayString(__props.humid) + " %", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, _toDisplayString(__props.press) + " hPa", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, _toDisplayString(__props.rainMin10) + " mm", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, _toDisplayString(__props.rainMin60) + " mm", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, _toDisplayString(__props.rainRui) + " mm", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, _toDisplayString(__props.rainfall) + " mm/h", 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})